__turbopack_context__.v({
  "offerSentWrapper": "styles-module__2ujx4G__offerSentWrapper",
  "offerSentWrapperTop": "styles-module__2ujx4G__offerSentWrapperTop",
});
